module.exports = __webpack_public_path__ + "img/POP-00015-3.6f572ffb.png";